import { create } from 'zustand';

export type FlowControlMediaExpandSource = 'manual' | 'playing' | null;

type FlowControlMediaExpandState = {
  expandId: string | null;
  expandSource: FlowControlMediaExpandSource;
  setExpandId: (expandId: string | null, source?: FlowControlMediaExpandSource) => void;
  toggleExpandId: (expandId: string) => void;
};

export const useFlowControlMediaExpandStore = create<FlowControlMediaExpandState>((set, get) => ({
  expandId: null,
  expandSource: null,
  setExpandId: (expandId, source = null) => set({ expandId, expandSource: source }),
  toggleExpandId: (expandId) => {
    const state = get();
    if (state.expandId === expandId) {
      set({ expandId: null, expandSource: null });
      return;
    }
    set({ expandId, expandSource: 'manual' });
  },
}));
